import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import client from './modules/client';
import group from './modules/group';
import machine from './modules/machine';
import producer from './modules/producer';
import stats from './modules/stats';
import system from './modules/system';
import wine from './modules/wine';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    client,
    group,
    machine,
    producer,
    stats,
    system,
    wine
  },
  strict: process.env.NODE_ENV !== 'production'
});
